<!-- Explore collection -->
<section class="ex-collection section-padding">
  <div class="container">
    <div class="row">
      <div class="col-12">
        <div class="section-header-left">
          <h3 class="text-light-black header-title title">
            Explore our collections
          </h3>
        </div>
      </div>
    </div>
    <div class="row">
      <div
        class="col-12 col-sm-6 col-md-6"
        *ngFor="let store of topRatedStores$ | async; let i = index"
      >
        <div
          class="ex-collection-box mb-3 mb-md-4 mb-xl-20"
          style="cursor: pointer"
          (click)="goToBusinessDetail(store.id)"
        >
          <!-- Skeleton Loader -->
          <div
            *ngIf="isTopRatedStoreImageLoading(store.id)"
            class="top-rated-store-image-skeleton"
            style="
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
              z-index: 0;
            "
          ></div>
          <!-- Store Image -->
          <img
            [src]="getStoreImage(store)"
            class="img-fluid full-width"
            [alt]="store.storeName"
            [attr.data-loading]="isTopRatedStoreImageLoading(store.id)"
            (load)="onTopRatedStoreImageLoad(store.id)"
            (error)="onTopRatedStoreImageError(store.id)"
            [style.opacity]="isTopRatedStoreImageLoading(store.id) ? '0' : '1'"
            [style.transition]="'opacity 0.3s ease-in-out'"
            [style.position]="'relative'"
            [style.z-index]="'1'"
            onerror="this.src='assets/img/restaurants/540x300/collection-' + (i + 1) + '.jpg'"
          />
          <div class="category-type overlay padding-15">
            <a
              (click)="$event.stopPropagation()"
              [routerLink]="['/businesses', store.id]"
              class="category-btn"
            >
              Top rated
              <span *ngIf="store.storeStats" class="ml-2">
                <i class="fas fa-heart text-danger"></i>
                <span class="d-none d-sm-inline">{{
                  formatLikes(store.storeStats.totalHeartsLiked || 0)
                }}</span>
              </span>
            </a>
          </div>
        </div>
      </div>
      <!-- Fallback skeleton loaders if no stores loaded -->
      <div
        class="col-12 col-sm-6 col-md-6"
        *ngIf="(topRatedStores$ | async)?.length === 0"
      >
        <div class="ex-collection-box mb-3 mb-md-4 mb-xl-20">
          <div style="position: relative; width: 100%">
            <div
              class="top-rated-store-image-skeleton"
              style="position: relative; width: 100%"
            ></div>
          </div>
          <div class="category-type overlay padding-15">
            <a routerLink="/businesses" class="category-btn">Top rated</a>
          </div>
        </div>
      </div>
      <div
        class="col-12 col-sm-6 col-md-6"
        *ngIf="(topRatedStores$ | async)?.length === 0"
      >
        <div class="ex-collection-box mb-3 mb-md-4 mb-xl-20">
          <div style="position: relative; width: 100%">
            <div
              class="top-rated-store-image-skeleton"
              style="position: relative; width: 100%"
            ></div>
          </div>
          <div class="category-type overlay padding-15">
            <a routerLink="/businesses" class="category-btn">Top rated</a>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <!-- Loading State -->
        <div
          *ngIf="isLoading$ | async"
          class="text-center"
          style="padding: 20px 10px"
        >
          <div class="spinner-border text-primary" role="status">
            <span class="sr-only">Loading...</span>
          </div>
          <p class="text-light-black mt-3">Loading businesses...</p>
        </div>

        <!-- Error State -->
        <div
          *ngIf="error$ | async as error"
          class="text-center"
          style="padding: 20px 10px"
        >
          <p class="text-danger">{{ error }}</p>
        </div>

        <!-- Businesses List -->
        <div *ngIf="businessesWithStats$ | async as businesses">
          <div
            *ngIf="businesses.length === 0 && !(isLoading$ | async)"
            class="text-center"
            style="padding: 20px 10px"
          >
            <p class="text-light-black">No businesses found.</p>
          </div>

          <div *ngIf="businesses.length > 0" class="row">
            <ng-container *ngFor="let business of businesses">
              <div
                class="col-12 col-sm-6 col-md-4 col-lg-3"
                (click)="goToBusinessDetail(business.id)"
              >
                <div
                  class="product-box mb-3 mb-md-4 mb-xl-20"
                  style="cursor: pointer"
                >
                  <div class="product-img" style="position: relative">
                    <a (click)="goToBusinessDetail(business.id)">
                      <!-- Skeleton Loader -->
                      <div
                        *ngIf="isBusinessImageLoading(business.id)"
                        class="business-store-image-skeleton"
                        style="
                          position: absolute;
                          top: 0;
                          left: 0;
                          width: 100%;
                          height: 100%;
                        "
                      ></div>
                      <!-- Business Image -->
                      <img
                        [src]="
                          business.storeLogo ||
                          business.banner ||
                          'assets/img/restaurants/255x150/shop-1.jpg'
                        "
                        class="img-fluid full-width"
                        [alt]="business.storeName"
                        style="
                          width: 100%;
                          height: auto;
                          position: relative;
                          z-index: 1;
                        "
                        [attr.data-loading]="
                          isBusinessImageLoading(business.id)
                        "
                        (load)="onBusinessImageLoad(business.id)"
                        (error)="onBusinessImageError(business.id)"
                        [style.opacity]="
                          isBusinessImageLoading(business.id) ? '0' : '1'
                        "
                        [style.transition]="'opacity 0.3s ease-in-out'"
                        onerror="this.src='assets/img/restaurants/255x150/shop-1.jpg'"
                      />
                    </a>
                    <div class="overlay">
                      <div class="product-tags padding-10">
                        <span class="circle-tag" *ngIf="business.storeStats">
                          <i class="fas fa-heart text-danger mr-1"></i>
                          {{
                            formatLikes(
                              business.storeStats.totalHeartsLiked || 0
                            )
                          }}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="product-caption">
                    <div class="title-box">
                      <h6 class="product-title">
                        <a
                          (click)="$event.stopPropagation()"
                          class="text-light-black"
                          style="cursor: pointer"
                        >
                          {{ business.storeName }}
                        </a>
                      </h6>
                    </div>
                    <div
                      *ngIf="business.type && business.type.length > 0"
                      class="mt-2"
                    >
                      <span
                        *ngFor="let type of business.type"
                        class="text-custom-white rectangle-tag bg-primary"
                        style="
                          width: fit-content;
                          display: inline-block;
                          margin-right: 5px;
                          margin-bottom: 5px;
                        "
                      >
                        {{ type | storeType }}
                      </span>
                    </div>
                    <div class="product-details mt-3">
                      <div class="price-time">
                        <span class="text-light-black time"
                          >{{ business.city }}, {{ business.state }}</span
                        >
                      </div>
                    </div>
                    <div
                      class="product-footer"
                      *ngIf="business.type && business.type.length > 0"
                    >
                      <span
                        class="text-custom-white square-tag"
                        *ngFor="let type of business.type"
                      >
                        <img
                          [src]="type | businessTypeToIcon"
                          [alt]="type | storeType"
                        />
                      </span>
                    </div>
                  </div>
                </div></div
            ></ng-container>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
